var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: { active: _vm.showResults }, attrs: { id: "search-input" } },
    [
      [
        _c("form", { staticClass: "search-container" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.value,
                expression: "value"
              }
            ],
            ref: "input",
            staticClass: "form-control border-0 shadow-dk pl-input",
            class: {
              "no-round-bottom":
                _vm.noRoundBottom && this.deviceType !== "mobile"
            },
            attrs: {
              "aria-label": "Search",
              autocomplete: "off",
              type: "search",
              placeholder: _vm.placeholder
            },
            domProps: { value: _vm.value },
            on: {
              keyup: function($event) {
                $event.preventDefault()
                return _vm.keyup.apply(null, arguments)
              },
              focus: _vm.searchFocus,
              blur: _vm.searchBlur,
              keydown: function($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                $event.preventDefault()
                $event.stopPropagation()
                return _vm.enter.apply(null, arguments)
              },
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.value = $event.target.value
              }
            }
          }),
          _vm._v(" "),
          this.deviceType === "mobile" && this.showResults
            ? _c(
                "i",
                {
                  staticClass:
                    "material-icons position-absolute search-icon md-24",
                  on: { click: _vm.searchHide }
                },
                [_vm._v("arrow_back_ios")]
              )
            : _c(
                "i",
                {
                  staticClass:
                    "material-icons position-absolute search-icon md-24"
                },
                [_vm._v("search")]
              ),
          _vm._v(" "),
          this.isLoading
            ? _c("div", { staticClass: "loading-dots" }, [
                _c("div", { staticClass: "dot" }),
                _vm._v(" "),
                _c("div", { staticClass: "dot" }),
                _vm._v(" "),
                _c("div", { staticClass: "dot" })
              ])
            : _vm._e(),
          _vm._v(" "),
          this.showResults
            ? _c(
                "i",
                {
                  staticClass: "material-icons close-btn md-24",
                  on: { click: _vm.searchClear }
                },
                [_vm._v("close")]
              )
            : _vm._e()
        ]),
        _vm._v(" "),
        _vm.hasResults && _vm.showResults
          ? _c(
              "div",
              {
                staticClass: "results-container",
                on: {
                  mouseenter: _vm.resultsMouseEnter,
                  mouseleave: _vm.resultsMouseLeave
                }
              },
              [
                _vm._l(_vm.results, function(res, index) {
                  return _c(
                    "div",
                    {
                      staticClass: "row no-gutters result",
                      class: { select: res.id === _vm.selected },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          $event.stopPropagation()
                          return _vm.resultSelect(res)
                        }
                      }
                    },
                    [
                      _c("div", { staticClass: "col text-truncate" }, [
                        _vm._v("\n\t\t\t\t\t" + _vm._s(res.title) + " "),
                        res.subtitle
                          ? _c("small", { staticClass: "text-muted" }, [
                              _vm._v(_vm._s(res.subtitle))
                            ])
                          : _vm._e(),
                        _c("br"),
                        _vm._v(" "),
                        res.footer
                          ? _c("small", { staticClass: "text-muted" }, [
                              _vm._v(_vm._s(res.footer))
                            ])
                          : _vm._e()
                      ])
                    ]
                  )
                }),
                _vm._v(" "),
                _vm.noResults
                  ? _c("div", { staticClass: "p-2" }, [
                      _c("span", { staticClass: "text-muted" }, [
                        _vm._v("No results found")
                      ])
                    ])
                  : _vm._e()
              ],
              2
            )
          : _vm._e()
      ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-33a9988c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-33a9988c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/search/search-input.vue
// module id = null
// module chunks = 